import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { toast } from "sonner";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: "", password: "", full_name: "", company: "", role: "customer" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await register(form);
      toast.success(`Welcome, ${u.full_name}`);
      navigate("/dashboard");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Registration failed");
    } finally { setLoading(false); }
  };

  return (
    <div className="max-w-md mx-auto px-6 py-20" data-testid="register-page">
      <div className="mono text-[11px] tracking-[0.22em] uppercase text-[#D97706]">// New Operator</div>
      <h1 className="display-black text-4xl uppercase text-[#064E3B] mt-3 tracking-tighter">Create account</h1>

      <form onSubmit={submit} className="mt-8 space-y-4 border border-gray-300 p-7" data-testid="register-form">
        <input className="input-federal" required placeholder="Full name" value={form.full_name} onChange={e => setForm({...form, full_name: e.target.value})} data-testid="reg-name" />
        <input className="input-federal" required type="email" placeholder="Email" value={form.email} onChange={e => setForm({...form, email: e.target.value})} data-testid="reg-email" />
        <input className="input-federal" required type="password" placeholder="Password" value={form.password} onChange={e => setForm({...form, password: e.target.value})} data-testid="reg-password" />
        <input className="input-federal" placeholder="Company (optional)" value={form.company} onChange={e => setForm({...form, company: e.target.value})} data-testid="reg-company" />
        <select className="input-federal" value={form.role} onChange={e => setForm({...form, role: e.target.value})} data-testid="reg-role">
          <option value="customer">Customer</option>
          <option value="hauler">Hauler</option>
          <option value="affiliate">Affiliate</option>
        </select>
        <button type="submit" disabled={loading} className="btn-federal w-full justify-center" data-testid="reg-submit">
          {loading ? "Creating…" : "Create account"}
        </button>
      </form>

      <div className="text-sm text-gray-700 mt-4">
        Already an operator? <Link to="/login" className="text-[#D97706] font-semibold hover:underline" data-testid="link-login">Sign in</Link>
      </div>
    </div>
  );
}
